import React, { useState, useEffect } from "react";
import { db } from "../../firebase/firebase";
import { collection, getDocs, doc, deleteDoc } from "firebase/firestore";
import "./AllInventory.css";
import InventoryForm from "../../components/InventoryForm/InventoryForm";
import { convertTimestampToDateTime } from "../../utils/ProductStatus";

const TransferedForBilling = () => {
    const [inventory, setInventory] = useState([]);
    const [filteredInventory, setFilteredInventory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [editableItem, setEditableItem] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [filterDate, setFilterDate] = useState("");
  

  
    const handleSaveClick = () => {
      setIsEditing(false);
      setEditableItem(null);
    };
  
    const handleCancelClick = () => {
      setIsEditing(false);
      setEditableItem(null);
    };
  

  
  
    useEffect(() => {
        const fetchInventory = async () => {
          try {
            const inventoryCollection = collection(db, "all-products");
            const inventorySnapshot = await getDocs(inventoryCollection);
            const inventoryList = inventorySnapshot.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }));
      
            // Filter items with status "sold" and history[1]?.status as "billed"
            const filtered = inventoryList.filter((inventory) => {
              const history = inventory.history || [];
              return (
               history.length==2 && history[1]?.status === "transferred"

              );
            });
      
            setInventory(filtered);
            setFilteredInventory(filtered);
          } catch (err) {
            setError(err.message);
          } finally {
            setLoading(false);
          }
        };
      
        fetchInventory();
      }, []);
      
  
    useEffect(() => {
      let filteredData = inventory;
  
      // Apply search query filter
      if (searchQuery) {
        filteredData = filteredData.filter(
          (item) =>
            item.model.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.variant.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.imei_1.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.imei_2.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.brand.toLowerCase().includes(searchQuery.toLowerCase()) ||
            (item.serialNumber &&
              item.serialNumber.toLowerCase().includes(searchQuery.toLowerCase())) ||
            (item.condition &&
              item.condition.toLowerCase().includes(searchQuery.toLowerCase()))
        );
      }
  
      // Apply date filter
      if (filterDate) {
        filteredData = filteredData.filter((item) => {
          if (!item.createdAt || !item.createdAt.seconds) {
            return false;
          }
          const itemDate = new Date(item.createdAt.seconds * 1000);
          const selectedDate = new Date(filterDate);
          return itemDate.toDateString() === selectedDate.toDateString();
        });
      }
  
      setFilteredInventory(filteredData);
    }, [searchQuery, filterDate, inventory]);
  
    if (loading) {
      return <div>Loading Inventory...</div>;
    }
  
    if (error) {
      return <div>Error: {error}</div>;
    }
  
    const groupedInventory = filteredInventory.reduce((acc, item) => {
      (acc[item.brand] = acc[item.brand] || []).push(item);
      return acc;
    }, {});
  
    return (
      <div className="inventory-container">
        {/* Search and Filter */}
        <div className="search-filter-container flex">
          <div>
            <input
              type="text"
              placeholder="Search by model, variant, or IMEI"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-inputb w-40 h-8 m-3 text-black rounded p-2"
            />
            <input
              type="date"
              value={filterDate}
              onChange={(e) => setFilterDate(e.target.value)}
              className="date-input w-40 h-8 m-3 text-black rounded p-2"
            />
          </div>
          <div className="flex ml-40">
            <div className="summary-item text-center mr-10">
              <h3 className="text-xl font-bold">Total Products</h3>
              <p className="text-lg">{filteredInventory.length}</p>
            </div>
            <div className="summary-item text-center">
              <h3 className="text-xl font-bold">Total Brands</h3>
              <p className="text-lg">
                {Object.keys(
                  filteredInventory.reduce((acc, item) => {
                    acc[item.brand] = true;
                    return acc;
                  }, {})
                ).length}
              </p>
            </div>
          </div>
        </div>
  
        {/* Grouped Inventory */}
        {Object.keys(groupedInventory).map((brand) => (
          <div key={brand} className="brand-group-inv">
            <h2 className="bg-red-600 py-1 flex items-center justify-center text-xl rounded-lg">
              {brand}
            </h2>
            <div className="card-container-inv">
              {groupedInventory[brand].map((item) => (
                <div
                  key={item.id}
                  className="inventory-card"
                  style={{ border: "1px solid black" }}
                >
                  {isEditing && editableItem.id === item.id ? (
                    <div>
                      <InventoryForm className="form-inventory" />
                      <button onClick={handleSaveClick}>Save</button>
                      <button onClick={handleCancelClick}>Cancel</button>
                    </div>
                  ) : (
                    <div className="edit-div text-sm" style={{ color: "black" }}>
                      <div className="flex justify-between">
                        <h3 className="text-xl">
                          <strong>{item.model}</strong>
                        </h3>
                        <div
                          className={`rounded-full p-2 flex justify-center items-center ${
                            item.condition === "Gold"
                              ? "bg-yellow-500"
                              : item.condition === "Platinum"
                              ? "bg-gray-300"
                              : item.condition === "Silver"
                              ? "bg-gray-400"
                              : "bg-yellow-300"
                          }`}
                        >
                          {item.condition}
                        </div>
                      </div>
                      <p>
                        <strong>Variant:</strong> {item.variant}
                      </p>
                      <p>
                        <strong>Condition:</strong> {item.condition}
                      </p>
                      <p>
                        <strong>Date Added:</strong>{" "}
                        {convertTimestampToDateTime(item.createdAt)}
                      </p>
                      <p>
                        <strong>IMEI 1:</strong> {item.imei_1}
                      </p>
                      <p>
                        <strong>IMEI 2:</strong> {item.imei_2}
                      </p>
                      <p>
                        <strong>Serial Number:</strong> {item.serialNumber}
                      </p>
                      {/* <p>
                        <strong>MRP:</strong>{" "}
                        {item.mrp ? `₹${item.mrp}` : "N/A"}
                      </p> */}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  };
  
export default TransferedForBilling;